import React, { useState, useEffect } from 'react';
import ImpdsStateIn from './ImpdsStateIn';
import ImpdsStateOut from './ImpdsStateOut';
import { CircularProgress } from '@mui/material';

const Impds = ({ month, year, trans, homeState, stateNameEn }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showStateIn, setShowStateIn] = useState(false);
  const [showStateOut, setShowStateOut] = useState(false);

  useEffect(() => {
    setShowStateIn(false);
    setShowStateOut(false);
    fetchData();
  }, [month, year, trans]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [transName, transComm] = trans.split('/@/');
      const response = await fetch(
        `${process.env.REACT_APP_URL_SIDE}/api/impds/data?month=${month}&year=${year}&transName=${transName}&transComm=${transComm}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      setData(result);
    } catch (error) {
      console.error('Error fetching data:', error);
      setData({
        distCount: 0,
        afsoCount: 0,
        fpsCount: 0,
        cardCount: 0,
        memberCount: 0,
        transData: {
          in_cards: 0,
          in_trans: 0,
          out_cards: 0,
          out_trans: 0
        },
        todayList: []
      });
    } finally {
      setLoading(false);
    }
  };

  const handleStateInClick = () => {
    setShowStateIn(true);
    setShowStateOut(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleStateOutClick = () => {
    setShowStateOut(true);
    setShowStateIn(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20px" }}>
      <CircularProgress/>
    </div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'
  ];
  const monthInt = parseInt(month);
  const [transName, transComm] = trans.split('/@/');

  return (
    <div style={{ paddingBottom: '100px' }}>
      <table align="center" style={{ borderCollapse: 'collapse', backgroundColor: 'cornsilk', width: '60%' }}>
        <tbody>
          <tr>
            <td align="center">
              <font size="4">
                <b>ONORC STATUS FOR THE MONTH OF {monthNames[monthInt-1]}, {year}</b>
              </font>
            </td>
          </tr>
          <tr align="center">
            <td align="center">
              <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <div style={{ textAlign: 'center', width: '110px', backgroundColor: '#f6ad43', padding: '15px', borderRadius: '20px' }}>
                  <font size="3px"><b>Districts</b></font><br />
                  <div align="center"><font size="3px"><b>{data.distCount || 0}</b></font></div>
                </div>
                <div style={{ textAlign: 'center', width: '110px', backgroundColor: '#b8d35f', padding: '15px', borderRadius: '20px' }}>
                  <font size="3px"><b>Offices</b></font><br />
                  <div align="center"><font size="3px"><b>{data.afsoCount || 0}</b></font></div>
                </div>
                <div style={{ textAlign: 'center', width: '110px', backgroundColor: '#e3499c', padding: '15px', borderRadius: '20px' }}>
                  <font size="3px"><b>FPS</b></font><br />
                  <div align="center"><font size="3px"><b>{data.fpsCount || 0}</b></font></div>
                </div>
                <div style={{ textAlign: 'center', width: '110px', backgroundColor: '#53a7ef', padding: '15px', borderRadius: '20px' }}>
                  <font size="3px"><b>Cards</b></font><br />
                  <div align="center"><font size="3px"><b>{data.cardCount || 0}</b></font></div>
                </div>
                <div style={{ textAlign: 'center', width: '110px', backgroundColor: '#4ab1a9', padding: '15px', borderRadius: '20px' }}>
                  <font size="3px"><b>Members</b></font><br />
                  <div align="center"><font size="3px"><b>{data.memberCount || 0}</b></font></div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      {data.transData ? (
        <table width="60%" style={{ margin: '0 auto' }}>
          <tbody>
            <tr className="tableheader">
              <th colSpan="4" bgcolor="#1785CF">
                <font style={{ color: '#fff' }}>{transName} ONORC TRANS FOR {monthNames[monthInt-1]} ' {year}</font>
              </th>
            </tr>
            <tr className="tableheader">
              <th colSpan="2" bgcolor="#1785CF">IN ↓</th>
              <th colSpan="2" bgcolor="#1785CF">OUT ↑</th>
            </tr>
            <tr className="tableheader">
              <th bgcolor="#1785CF">CARDS</th>
              <th bgcolor="#1785CF">TRANS</th>
              <th bgcolor="#1785CF">CARDS</th>
              <th bgcolor="#1785CF">TRANS</th>
            </tr>
            <tr>
              <td align="center">{data.transData.in_cards || 0}</td>
              <td align="center">
                {data.transData.in_trans > 0 ? (
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={handleStateInClick}
                  >
                    {data.transData.in_trans}
                  </a>
                ) : (
                  data.transData.in_trans || 0
                )}
              </td>
              <td align="center">{data.transData.out_cards || 0}</td>
              <td align="center">
                {data.transData.out_trans > 0 ? (
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={handleStateOutClick}
                  >
                    {data.transData.out_trans}
                  </a>
                ) : (
                  data.transData.out_trans || 0
                )}
              </td>
            </tr>
          </tbody>
        </table>
      ) : (
        <div className="mainhead" align="center">NO Transaction Available</div>
      )}
      <br />
      <table align="center" width="60%" style={{ borderCollapse: 'collapse' }}>
        <tbody>
          <tr className="tableheader">
            <th colSpan="4" bgcolor="#1785CF">
              <font style={{ color: '#fff', fontWeight: 'bold' }}>TODAY'S {transName} TRANSACTIONS</font>
            </th>
          </tr>
          {data.todayList && data.todayList.length > 0 ? (
            <>
              <tr className="tableheader">
                <th colSpan="2" bgcolor="#1785CF">IN ↓</th>
                <th colSpan="2" bgcolor="#1785CF">OUT ↑</th>
              </tr>
              <tr className="tableheader">
                <th bgcolor="#1785CF">CARDS</th>
                <th bgcolor="#1785CF">TRANS</th>
                <th bgcolor="#1785CF">CARDS</th>
                <th bgcolor="#1785CF">TRANS</th>
              </tr>
              <tr>
                <td align="center">{data.todayList[0]?.in_cards || 0}</td>
                <td align="center">{data.todayList[0]?.in_trans || 0}</td>
                <td align="center">{data.todayList[0]?.out_cards || 0}</td>
                <td align="center">{data.todayList[0]?.out_trans || 0}</td>
              </tr>
            </>
          ) : (
            <tr>
              <td colSpan="4" align="center" style={{ padding: '10px' }}>
                <b>NO TRANSACTION FOUND TODAY</b>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <br />
      <center>
        <a
          href={`${process.env.REACT_APP_URL_SIDE}/api/impds/export-state-in?month=${month}&year=${year}&transName=${transName}&transComm=${transComm}&homeState=${homeState}&stateNameEn=${stateNameEn}&exportToExcel=YES`}
          style={{ fontSize: '15px', fontWeight: 'bold', color: 'blue' }}
        >
          Download {transName} ONORC drawal in {stateNameEn} for the month of {monthNames[monthInt - 1]}-{year}
        </a>
        <br /><br />
        <a
          href={`${process.env.REACT_APP_URL_SIDE}/api/impds/export-state-out?month=${month}&year=${year}&transName=${transName}&transComm=${transComm}&homeState=${homeState}&exportToExcel=YES`}
          style={{ fontSize: '15px', fontWeight: 'bold', color: 'blue' }}
        >
          Download {transName} ONORC drawal in other states for the month of {monthNames[monthInt - 1]}-{year}
        </a>
      </center>
      <br /><br />
      {showStateIn && (
        <ImpdsStateIn
          month={month}
          year={year}
          homeState={homeState}
          transName={transName}
          transComm={transComm}
          onClose={() => {
            setShowStateIn(false);
            setShowStateOut(false);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        />
      )}
      {showStateOut && (
        <ImpdsStateOut
          month={month}
          year={year}
          homeState={homeState}
          transName={transName}
          transComm={transComm}
          onClose={() => {
            setShowStateIn(false);
            setShowStateOut(false);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        />
      )}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        style={{
          position: 'fixed',
          right: '18px',
          bottom: '18px',
          zIndex: 9999,
          backgroundColor: '#f1872bff',
          color: '#100d0dff',
          border: 'none',
          padding: '12px 14px',
          borderRadius: '20px',
          boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
          cursor: 'pointer'
        }}
        title="Back to Top"
      >
        Top
      </button>
    </div>
  );
};

export default Impds;
